import {createSlice} from '@reduxjs/toolkit';
import type {PayloadAction} from '@reduxjs/toolkit';

export interface ShopState {
  loadingPagination: {[key: string]: boolean};
  editingParams: {[key: string]: {[key: string]: boolean}};
}

const initialState: ShopState = {
  loadingPagination: {},
  editingParams: {},
};

export const shopSlice = createSlice({
  name: 'shop',
  initialState,
  reducers: {
    setPaginationState: (
      state,
      action: PayloadAction<{[key: string]: boolean}>,
    ) => {
      const key = Object.keys(action.payload)[0];
      state.loadingPagination[key] = action.payload[key];
    },
    setEditingParams(
      state,
      action: PayloadAction<{
        [key: string]: {[key: string]: boolean};
      }>,
    ) {
      const key = Object.keys(action.payload)[0];
      if (!state.editingParams[key]) {
        state.editingParams[key] = action.payload[key];
      } else {
        const key0 = Object.keys(action.payload[key])[0];
        state.editingParams[key][key0] = action.payload[key][key0];
      }
    },
  },
});

export const {setEditingParams} = shopSlice.actions;

export default shopSlice.reducer;
